/* Component-specific styles only */
:host {
  display: block;
}
.link {
  text-decoration: underline;
  font-weight: var(--font-weight-bold);
}
.description {
  margin-bottom: var(--margin-xxl);
  color: var(--color-text-secondary);
  font-size: var(--font-size);
  line-height: 1.5;
}
.description strong {
  color: var(--color-text-primary);
  font-weight: 500;
}
.add-form {
  display: flex;
  gap: var(--margin);
  margin-bottom: var(--margin-xxl);
  padding-bottom: var(--padding-xxl);
  border-bottom: var(--border);
}
.add-form input {
  flex: 1;
  padding: var(--padding);
  border: var(--border);
  border-radius: var(--border-radius);
  background: var(--color-bg-secondary);
}
.add-form button {
  padding: var(--padding) var(--padding-xl);
  background: var(--color-bg-accent);
  color: var(--color-text-inverse);
  border: none;
  border-radius: var(--border-radius);
  cursor: pointer;
  white-space: nowrap;
}
.add-form button:hover {
  background: var(--color-text-accent);
}
.links-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.link-item {
  display: flex;
  align-items: center;
  gap: var(--margin-xl);
  padding: var(--padding-l);
  border: var(--border);
  border-radius: var(--border-radius);
  margin-bottom: var(--margin);
  background: var(--color-bg-primary);
  cursor: grab;
}
.link-item.drag-over {
  border-color: var(--color-bg-accent);
  background: var(--color-bg-secondary);
}
.drag-handle {
  color: var(--color-disabled);
  cursor: grab;
}
.link-content {
  flex: 1;
  min-width: 0;
}
.link-title {
  font-weight: var(--font-weight-medium);
  margin-bottom: var(--margin-s);
}
.link-url {
  font-size: var(--font-size-s);
  color: var(--color-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.edit-form {
  display: flex;
  gap: var(--margin);
  flex: 1;
}
.edit-form input {
  flex: 1;
  padding: var(--padding-s) var(--padding);
  border: var(--border);
  border-radius: var(--border-radius);
  background: var(--color-bg-secondary);
}
@media (max-width: 768px) {
  .add-form {
    flex-direction: column;
    gap: var(--padding-l);
    margin-bottom: var(--padding-xl);
    padding-bottom: var(--padding-xl);
  }
  .add-form input {
    width: 100%;
    padding: var(--padding-l);
    font-size: var(--font-size);
  }
  .add-form button {
    width: 45%;
    margin-left: auto;
    padding: var(--padding-l);
    font-size: var(--font-size);
  }
  .link-item {
    flex-wrap: wrap;
    gap: var(--padding-l);
    padding: var(--padding-l);
    margin-bottom: var(--padding-l);
  }
  .link-content {
    width: 100%;
  }
  .link-title {
    margin-bottom: var(--padding);
    font-size: var(--font-size);
  }
  .link-url {
    font-size: var(--font-size);
  }
  .edit-form {
    flex-direction: column;
    width: 100%;
    gap: var(--padding-l);
    flex-wrap: wrap;
  }
  .edit-form input {
    width: 100%;
    padding: var(--padding-l);
    font-size: var(--font-size);
  }
}
